import React from "react"
import { useLocation, Link } from "react-router-dom"
import * as layouts from "layouts"
import * as titlebars from "titlebars"
import * as brands from "brands"
import * as routing from "./routing"

interface LinkProps {
	title: string
	urlgen(bid: string): string
}

function ActiveLink(props: LinkProps): JSX.Element {
	const brand = brands.caching.useCached()
	const location = useLocation()
	const link = props.urlgen(brand.id)
	const isactive = location.pathname.startsWith(link)

	return (
		<layouts.containers.flex pr="2px">
			<Link to={link}>
				<titlebars.navigation.Button
					width="120px"
					height="40px"
					disabled={isactive}
					className={`${isactive ? "active" : ""}`}
				>
					{props.title}
				</titlebars.navigation.Button>
			</Link>
		</layouts.containers.flex>
	)
}

export function SubNavigation(): JSX.Element {
	return (
		<layouts.containers.flex
			flexDirection="row"
			borderRadius="10px"
			mb="10px"
			mt="5px"
			background={layouts.theme.colors.white}
		>
			<ActiveLink title="Documents" urlgen={routing.documents} />
			<ActiveLink title="Review Assets" urlgen={routing.allAssets} />
		</layouts.containers.flex>
	)
}
